import { useEffect, useState } from "react";
import { ALL } from "../consts";
import { useGetIncidentList } from "@/services";
import { Badge } from "@/components/ui";
import { cn, incidentStatus, toApiSort } from "@/lib/utils";

const useOccupantsDialog = ({ selectedRow }: {selectedRow: any}) => {
  const [activeTab, setActiveTab] = useState<string>(ALL);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [sorting, setSorting] = useState([{ id: "createdAt", desc: true }]);

  const {
    data: incidentList,
    isLoading: isIncidentLoading,
    refetch: refetchIncident,
    isRefetching: isIncidentRefetching,
  } = useGetIncidentList({
    communityId: selectedRow?.communityId,
    data: {
      filters: [
        {
          field: "propertyId",
          value: selectedRow?.propertyId,
          operator: "EQUAL",
        },
        ...(activeTab != ALL ? activeTab == "close" ? [{
          field: "status",
          value: ["CHARGED_CLOSED", "CITATION_CLOSED"],
          operator: "CONTAINS_ANY",
        }] : [{
          field: "status",
          value: activeTab?.toUpperCase(),
          operator: "EQUAL",
        }] : []),
      ],
      pageNumber,
      pageSize,
      sort: toApiSort(sorting, { field: "createdAt", direction: "DESC" }),
    },
    queryParams: {
      enabled: Boolean(selectedRow?.communityId),
    },
  });

  useEffect(() => {
    refetchIncident();
  }, [pageNumber, pageSize, sorting]);

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
    setTimeout(() => refetchIncident(), 100);
  }
  
  const columns = [
    {
      accessorKey: "incidentId",
      header: <div>Incident</div>,
      accessorFn: (row: any) => String(row?.incidentId || ""),
      cell: ({row}: any) => {
        const {incidentId, incidentCategoryName} = row?.original;

        return <div className="flex flex-col">
          <span>{incidentId}</span>
          <span className="text-[10px] text-gray-500">{incidentCategoryName}</span>
        </div>
      },
    },
    {
      accessorKey: "reportedByUserName",
      header: <div>Raised By</div>,
      accessorFn: (row: any) => String(row?.reportedByUserName || ""),
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: (row: any) => {
        const statusKey = row?.row?.original?.status?.toLowerCase();
        const statusConfig = (incidentStatus as any)?.[statusKey];
        return (
          <Badge
            variant="outline"
            className={cn(
              statusConfig?.color,
              "rounded-full px-4 py-2"
            )}
          >
            {statusConfig?.label || row?.row?.original?.status}
          </Badge>
        );
      },
    },
  ]

  return {
    activeTab,
    onTabChange,
    columns,
    incidentList,
    isDocLoading: isIncidentLoading || isIncidentRefetching,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
  }
}

export default useOccupantsDialog;